import React, { useState } from "react";
import { ButtonToolbar } from "react-bootstrap";
import { Modal, Button } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { useFormik } from "formik";
import ErrorModal from "./ErrorModal";
import UpdatedSuccessfulModal from "./UpdatedSuccessfulModal";
import { AddProductSchema } from "../../utils/FormikSchema";
import { addProductApi } from "../../../axios/services/services";

const initialValues = {
  material_code: "",
  serial_number: "",
  dealer_code:""
};

function AddProductModal({
  isAddProductModalShow,
  hideAddProductModal,
  handleSuccessOfAddProduct,
}) {
  const [loading, setLoading] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

  const formik = useFormik({
    initialValues,
    validationSchema: AddProductSchema,
    onSubmit: async (values, { setStatus, setSubmitting, resetForm }) => {
      const { material_code, serial_number,dealer_code } = values;
      enableLoading();
      let addProductObj = {
        materialCode: material_code,
        serialNumber: serial_number,
        dealer_code:dealer_code,
      };
      const addProductResponse = await addProductApi(addProductObj);
      disableLoading();
      const { Error } = addProductResponse || {};
      if (Error) {
        const { message } = Error || {};
        setErrorMessage(message);
        handleErrorModalShow();
        return;
      }
      resetForm();
      handleSuccessOfAddProduct(Math.random());
      setSuccessMessage("Product Added Successfully.");
      handleSuccessModalShow();
      setTimeout(() => {
        hideAddProductModal();
      }, 2500);
    },
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };
  const handleErrorModalShow = () => {
    setIsErrorModalOpen(true);
  };

  const handleErrorModalHide = () => {
    setIsErrorModalOpen(false);
  };
  const handleSuccessModalShow = () => {
    setIsSuccessModalOpen(true);
  };

  const handleSuccessModalHide = () => {
    setIsSuccessModalOpen(false);
  };
  return (
    <>
      <Modal
        show={isAddProductModalShow}
        onHide={() => {
          formik.resetForm();
          hideAddProductModal();
        }}
        dialogClassName="modal-90w"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title
            className="d-flex justify-content-between w-100"
            id="contained-modal-title-vcenter"
          >
            Add New Product
            <Button
              variant="btn p-0 d-flex justify-content-end"
              onClick={hideAddProductModal}
            >
              <span className="svg-icon svg-icon-secondary svg-icon-2x mr-0">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Navigation/Close.svg")}
                />
              </span>
            </Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={formik.handleSubmit} autoComplete="off">
            <div className="form-group mt-2">
              <input
                placeholder="Material Code*"
                autoComplete="off"
                type="text"
                className="form-control h-auto py-5 px-6 mb-2 text-capitalize"
                name="material_code"
                {...formik.getFieldProps("material_code")}
              />
              {formik.touched.material_code && formik.errors.material_code ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">
                    {formik.errors.material_code}
                  </div>
                </div>
              ) : null}

              <input
                placeholder="Serial Number*"
                autoComplete="off"
                type="text"
                className="form-control h-auto py-5 px-6 mb-2 text-capitalize"
                name="serial_number"
                {...formik.getFieldProps("serial_number")}
              />
              {formik.touched.serial_number && formik.errors.serial_number ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">
                    {formik.errors.serial_number}
                  </div>
                </div>
              ) : null}
              <input
                placeholder="Dealer Code"
                autoComplete="off"
                type="text"
                className="form-control h-auto py-5 px-6 mb-2 text-capitalize"
                name="dealer_code"
                {...formik.getFieldProps("dealer_code")}
              />
              {formik.touched.dealer_code && formik.errors.dealer_code ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">
                    {formik.errors.dealer_code}
                  </div>
                </div>
              ) : null}
            </div>

            <ButtonToolbar className="d-flex justify-content-end button-wrap">
              <Button
                type="submit"
                variant="btn btn-success mr-3"
                disabled={loading}
              >
                Add Product
                {loading && (
                  <span className="ml-3 mr-3 spinner spinner-white"></span>
                )}
              </Button>
              <Button
                variant="btn btn-light-dark"
                onClick={() => {
                  formik.resetForm();
                  hideAddProductModal();
                }}
                disabled={loading}
              >
                Cancel
              </Button>
            </ButtonToolbar>
          </form>
        </Modal.Body>
      </Modal>
      <ErrorModal
        message={errorMessage}
        isErrorModalOpen={isErrorModalOpen}
        hideErrorModal={handleErrorModalHide}
        errorIcon={
          <div className="danger-icon-wrapper text-center">
            <span className="svg-icon menu-icon svg-icon-white svg-icon-4x mr-0">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Navigation/Close.svg")}
              />
            </span>
          </div>
        }
        errorButtonLabel={"Close"}
        errorOnClick={handleErrorModalHide}
      />
      <UpdatedSuccessfulModal
        message={successMessage}
        UpdatedSuccessfulModalShow={isSuccessModalOpen}
        UpdatedSuccessfulModalHide={handleSuccessModalHide}
        successIcon={
          <div className="success-icon-wrapper text-center">
            <span className="svg-icon menu-icon svg-icon-white svg-icon-4x mr-0">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Navigation/Check.svg")}
              />
            </span>
          </div>
        }
      />
    </>
  );
}
export default AddProductModal;
